import React from 'react';
import styled from 'styled-components';
import companies from '../../services/companies';
import SEO from '../../components/seo';
import Layout from '../../components/layout';
import Image from '../../components/image';
import ListWrapper from '../../components/list';
import { Typography } from '../../components/typography';
import Avatar from '../../components/avatar';

const Container = styled.div`
  background-color: white;
  margin: 0 auto;
  min-height: 46rem;
  width: 100vw;
`;

const Wrapper = styled.div`
  margin: 0 auto;
  margin-top: 5rem;
  margin-bottom: 5rem;
  max-width: 80rem;
`;

const TextWrapper = styled.h2`
  margin: 0 auto;
  max-width: 36rem;
`;

const Company = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 2rem 0rem;
  width: 200px;
  @media (min-width: 968px) {
    margin: 1rem;
  }
`;

const About = ({ location: { pathname } }) => {
  return (
    <Layout location={pathname}>
      <Avatar defaultImage="avatar.png" hoverImage="avatar.hover.png" />
      <SEO
        title="About | Software Developer"
        description="Personal Web Developer Portfolio. I'm a Fullstack developer with emphasis on Front-End and JavaScript specialist"
      />
      <Container>
        <Wrapper>
          <TextWrapper>
            <Typography fontSize="1.75rem" fontWeight={700} textAlign="center">
              I&apos;m proud to have collaborated with some awesome companies:
            </Typography>
          </TextWrapper>
          <ListWrapper maxWidth="50rem" justifyContent="space-evenly">
            {companies.map((company) => (
              <a href={company.url} target="_blank" rel="noopener noreferrer">
                <Company key={company.id}>
                  <Image
                    alt={company.name}
                    src={company.logo}
                    maxHeight="7rem"
                  />
                </Company>
              </a>
            ))}
          </ListWrapper>
        </Wrapper>
      </Container>
    </Layout>
  );
};

export default About;
